import { ref, computed, watch } from 'vue'

export function useCollapsible(props: any): any {
  const collapsibleTarget = ref(props.entry?.configuration?.collapsible?.target ?? -1)

  const collapsibleButtonShow = computed(() => {
    return collapsibleTarget.value > 0
  })

  const collapsibleState = ref(props.entry?.state?.collapsible?.state ?? 'closed')

  const collapsibleButtonStateIsOpen = computed(() => {
    return collapsibleState.value === 'open'
  })

  const collapsibleButtonStateIsOpenMessage = computed(() => {
    return props.config?.collapsible?.open ?? 'Schliessen'
  })

  const collapsibleButtonStateIsClosedMessage = computed(() => {
    return props.config?.collapsible?.closed ?? 'Öffnen'
  })

  const collapsibleSelectionEnabled = ref(props.config.selection?.enabled ?? false)

  const columnsCount = ref(props.columncount)

  const columnsContentCount = computed(() => {
    return columnsCount.value - 1
  })

  watch(
    () => props,
    (n) => {
      collapsibleTarget.value = n.entry.configuration?.collapsible?.target ?? -1
      collapsibleState.value = n.entry.state?.collapsible?.state ?? 'closed'
      collapsibleSelectionEnabled.value = n.config.selection?.enabled ?? false
      columnsCount.value = n.columncount
    },
    { deep: true }
  )

  return {
    collapsibleButtonShow,
    collapsibleButtonStateIsOpen,
    collapsibleButtonStateIsOpenMessage,
    collapsibleButtonStateIsClosedMessage,
    collapsibleSelectionEnabled,
    columnsContentCount
  }
}
